export const canEditConfirmedOrder = (order) =>
  order?.status === "pending" &&
  order?.paymentStatus === "pending" &&
  Array.isArray(order.products) &&
  order.products.every((line) => line.status === "pending");
export const canRecoverOrder = (order) =>
  Boolean(order?.orderId) &&
  order.paymentStatus === "pending" &&
  ["pending", "inPreparation", "prepared"].includes(order.status) &&
  !order.archivedAt;

export const isHomeDeliveryOrder = (order, methods = []) => {
  if (order?.fulfillment?.type) return order.fulfillment.type === "delivery";
  return methods.some(
    (method) =>
      method.nameHomeDelivery &&
      method.nameHomeDelivery !== method.nameStoreDelivery &&
      method.nameHomeDelivery === order?.shippingMethod,
  );
};
